import fullRed from "../../assets/logos/full-red.png";
import fullWhite from "../../assets/logos/full-white.png";
import fullBlack from "../../assets/logos/full-black.png";

// Full ProximityParks lockup (icon + wordmark) — use this anywhere the old
// hand-rolled `<PPIcon /> + <span>Proximity</span><span>Parks</span>`
// composition was used. Pulls the actual brand asset so typography matches.
// `height` controls the rendered size; width auto-scales.
export default function PPLogo({ height = 28, variant = "red" }) {
  const src = variant === "white" ? fullWhite : variant === "black" ? fullBlack : fullRed;
  return (
    <img
      src={src}
      alt="ProximityParks"
      height={height}
      style={{ display: "block", height, width: "auto", flexShrink: 0 }}
      draggable={false}
    />
  );
}
